// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isLocal: false,
  impersonatedUser: '',
  api: '/api',
  //appVersion: require('../../package.json').version,
  //chemistryVersion: require('../../package.json').dependencies["sv-chemistry-ng-lib"],
  aboutUsUrl: 'https://test.supervalu.com',
  privacyUrl: 'https://test.supervalu.com/misc/privacy-policy.html',
  termsUrl: 'https://qa-myhome.svharbor.com/content/svpublic/terms.html',
  svHarborExitUrl: 'https://portaltest.svharbor.com/portal/servlet/svHarbor',
  svHarborLogoutUrl: 'https://wwwtest.svharbor.com/logout.html',
  svConnectUrl: 'https://test-svcportal.svharbor.com/svcportal/home.jsf',
  helpUrl: '/assets/docs/help_doc.pdf',
  guardLoginUrl: '/api/oauth2/authorization/guard',
  guardLogoutUrl: '/api/logout',
  googleTagManagerId: ''
};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
